"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _material = require("@mui/material");
var d3 = _interopRequireWildcard(require("d3"));
var _d3OrgChart = require("d3-org-chart");
var _react = _interopRequireWildcard(require("react"));
var _server = require("react-dom/server");
var _iconsCenter = require("../../resources/icons-center.svg");
var _iconsOrgChart = require("../../resources/icons-org-chart.svg");
var _iconsWarning = require("../../resources/icons-warning.svg");
var _iconsZoomin = require("../../resources/icons-zoomin.svg");
var _iconsZoomout = require("../../resources/icons-zoomout.svg");
var _iconsSearch = require("../../resources/icons-search.svg");
var _klayowebshared = require("klayowebshared");
var _ButtonGroup = _interopRequireDefault(require("../buttons/ButtonGroup"));
var _Placeholder = _interopRequireDefault(require("../layouts/Placeholder"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _OrgChartButton = _interopRequireDefault(require("./OrgChartButton"));
var _OrgChartCompanyNode = _interopRequireDefault(require("./OrgChartCompanyNode"));
var _OrgChartPersonNode = _interopRequireDefault(require("./OrgChartPersonNode"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var OrgChart = exports["default"] = /*#__PURE__*/function (_Component) {
  function OrgChart(props) {
    var _this;
    _classCallCheck(this, OrgChart);
    _this = _callSuper(this, OrgChart, [props]);
    _defineProperty(_this, "handleSearchClick", function (event) {
      _this.setState({
        searchAnchorEl: event.currentTarget
      });
    });
    _defineProperty(_this, "handleSearchClose", function () {
      _this.setState({
        searchAnchorEl: null
      });
    });
    _defineProperty(_this, "handleEmployeeSelect", function (event, employee) {
      if (employee) {
        // Clear previous highlights
        var data = _this.props.data;
        if (data) {
          data.orgTree.forEach(function (emp) {
            if (emp.highlight) {
              _this.setHighlightSearch(emp.employeeId, false);
            }
          });
        }

        // Highlight and focus on selected employee
        _this.setHighlightSearch(employee.employeeId, true);
        _this.focusOnEmployee(employee.employeeId);
      }
      _this.setState({
        selectedEmployee: employee
      });
    });
    _defineProperty(_this, "handleSearchChange", function (event) {
      var value = event.target.value;
      _this.setState({
        searchValue: value
      });
      var _this$props = _this.props,
        data = _this$props.data,
        searchFilter = _this$props.searchFilter;
      if (!value || !data || !searchFilter) {
        // Clear all highlights when search is empty
        if (data) {
          data.orgTree.forEach(function (emp) {
            if (emp.highlight) {
              _this.setHighlightSearch(emp.employeeId, false);
            }
          });
        }
        _this.searchResults = null;
        _this.forceUpdate();
        return;
      }
      _this.forceUpdate();
    });
    _defineProperty(_this, "focusOnEmployee", function (employeeId) {
      try {
        if (!_this.orgChart) return;

        // Expand the node and its parents
        _this.setExpanded(employeeId, true);
        var employee = _this.getEmployee(employeeId);
        if (employee) {
          _this.expandAllParents(employee);
        }
        var node = _this.getNode(employeeId);
        if (!node) return;

        //fit method to center on the node without scaling
        _this.orgChart.fit({
          nodes: [node],
          animate: true,
          scale: false,
          centerMind: true,
          duration: 500
        });
        _this.forceUpdate();
      } catch (e) {
        console.error("Error in focusOnEmployee:", e);
      }
    });
    _defineProperty(_this, "setHighlightSearch", function (employeeId, highlight) {
      try {
        var employee = _this.getEmployee(employeeId);
        if (employee) {
          employee.highlight = highlight;
          _this.setExpanded(employeeId, true);
          _this.orgChart.render(); // Re-render to show highlight
        }
      } catch (e) {
        console.error("Error setting highlight:", e);
      }
    });
    _this.state = {
      actionEmployee: null,
      actionTarget: null,
      centerOn: props.centerOn,
      currentUser: props.currentUser,
      tooltipText: null,
      tooltipOffset: {
        x: 0,
        y: 0
      },
      tooltipTarget: null,
      searchAnchorEl: null,
      searchValue: "",
      selectedEmployee: null
    };
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    _this.zoomInRef = /*#__PURE__*/_react["default"].createRef();
    _this.zoomOutRef = /*#__PURE__*/_react["default"].createRef();
    _this.resetRef = /*#__PURE__*/_react["default"].createRef();
    _this.searchRef = /*#__PURE__*/_react["default"].createRef();
    _this.zoom = 1;
    _this.center = {
      x: 0,
      y: 0
    };
    _this.centering = true;
    _this.firstDraw = true;
    _this.lastX = 0;
    _this.lastY = 0;

    //Temp until safari bugs fixed (can't target specific behaviour foreignObject overflow)
    _this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    window.addEventListener("resize", _this.onWindowResize.bind(_this));
    return _this;
  }
  _inherits(OrgChart, _Component);
  return _createClass(OrgChart, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      //if (this.props.data !== prevProps.data) this.setState({ data: this.props.data });
      if (this.props.centerOn !== prevProps.centerOn) this.setState({
        centerOn: this.props.centerOn
      });
      if (this.props.search !== prevProps.search) this.onSearch(this.props.search);
      if (this.props.organization !== prevProps.organization) this.forceUpdate();
    }
  }, {
    key: "onWindowResize",
    value: function onWindowResize(e) {
      this.onReset();
    }
  }, {
    key: "onSearch",
    value: function onSearch(search) {
      var _this$props2 = this.props,
        data = _this$props2.data,
        searchFilter = _this$props2.searchFilter;
      if (!search || search === "") {
        this.searchResults = null;
        this.forceUpdate();
        return;
      }
      this.search = search;
      if (this.search && searchFilter) {
        this.searchResults = data.orgTree.filter(function (n) {
          return searchFilter(n, search);
        });
      }
    }
  }, {
    key: "renderOrgChart",
    value: function renderOrgChart() {
      var _this2 = this;
      if (!this.containerRef || !this.containerRef.current) return;
      var _this$props3 = this.props,
        data = _this$props3.data,
        height = _this$props3.height,
        minZoom = _this$props3.minZoom,
        maxZoom = _this$props3.maxZoom,
        currentUser = _this$props3.currentUser,
        nodeWidth = _this$props3.nodeWidth;
      var centerOn = this.state.centerOn;
      if (!data) return;
      var orgChart = this;
      if (!this.orgChart) {
        this.orgChart = new _d3OrgChart.OrgChart().container(this.containerRef.current).data(data.orgTree).layout("top");
        var origZoom = this.orgChart.zoomed;
        this.orgChart.zoomed = function (e, d) {
          orgChart.onZoom(e, e.transform.k);
          orgChart.onPan(e, e.transform.x, e.transform.y);

          /*if(e.sourceEvent instanceof MouseEvent) {
                       const xDiff = Math.abs(e.transform.x - orgChart.lastX);
                      const yDiff = Math.abs(e.transform.y - orgChart.lastY);
                       if(xDiff > 2 || yDiff > 2) {
                          origZoom.call(this, e, d);
                           orgChart.lastX = e.transform.x;
                          orgChart.lastY = e.transform.y;
                      }
                  }
                  else*/
          origZoom.call(this, e, d);
        };
        this.orgChart.zoomTreeBounds = function (_ref) {
          var x0 = _ref.x0,
            x1 = _ref.x1,
            y0 = _ref.y0,
            y1 = _ref.y1,
            _ref$params = _ref.params,
            params = _ref$params === void 0 ? {
              animate: true,
              scale: true
            } : _ref$params;
          if (!orgChart.containerRef || !orgChart.containerRef.current) return;
          var _this$getChartState = this.getChartState(),
            centerG = _this$getChartState.centerG,
            svg = _this$getChartState.svg,
            zoomBehavior = _this$getChartState.zoomBehavior,
            duration = _this$getChartState.duration,
            lastTransform = _this$getChartState.lastTransform;
          var w = orgChart.containerRef.current.clientWidth;
          var h = orgChart.containerRef.current.clientHeight;
          var scaleVal = Math.min(8, 0.9 / Math.max((x1 - x0) / w, (y1 - y0) / h));
          var identity = d3.zoomIdentity.translate(w / 2, h / 2);
          identity = identity.scale(params.scale ? scaleVal : lastTransform.k);
          var offsetY = orgChart.containerRef.current.clientHeight / 100 * 15;
          identity = identity.translate(-(x0 + x1) / 2, -(y0 + y1) / 2 - offsetY);
          svg.transition().duration(params.animate ? duration : 0).call(zoomBehavior.transform, identity);
          centerG.transition().duration(params.animate ? duration : 0).attr("transform", "translate(0,0)");
        };
        var origSetExpansionFlagToChildren = this.orgChart.setExpansionFlagToChildren;
        this.orgChart.setExpansionFlagToChildren = function (d, expand) {
          if (d.data._expanded === undefined) return;
          //if(!d.data._expanded)
          origSetExpansionFlagToChildren.call(this, d, expand);
        };

        /*const origonButtonClick = this.orgChart.onButtonClick;
              this.orgChart.onButtonClick = function(e, d) {
                  e.preventDefault();
                  e.stopPropagation();
                  origonButtonClick.call(this, e, d);
              }*/

        setTimeout(function (t) {
          return _this2.centering = false;
        }, 1000);
      }
      this.orgChart = this.orgChart.svgHeight(orgChart.containerRef.current.clientHeight).compact(false).scaleExtent([minZoom, maxZoom]).parentNodeId(function (d) {
        return d.parentId;
      }).nodeHeight(function (d) {
        if (d.data.type === "person") return 152;else if (d.data.type === "company") return 124;
        return 85;
      }).nodeWidth(function (d) {
        return nodeWidth;
      }).childrenMargin(function (d) {
        return 80;
      }).compactMarginBetween(function (d) {
        return 25;
      }).compactMarginPair(function (d) {
        return 50;
      }).neightbourMargin(function (a, b) {
        return 25;
      }).siblingsMargin(function (d) {
        return 25;
      }).buttonContent(this.renderButton.bind(this)).linkUpdate(function (d, i, arr) {
        orgChart.linkUpdate(this, d, i, arr);
      }).nodeContent(this.renderNode.bind(this)).nodeUpdate(function (d, i, arr) {
        orgChart.nodeUpdate(this, d, i, arr);
      });

      //this.orgChart.setLayouts({ expandNodesFirst: false });

      //this.orgChart.setExpanded('73c94c77-b11b-4bf3-a9a2-450de95b530a').render();
      if (this.firstDraw && currentUser) {
        this.firstDraw = false;
        this.orgChart.setLayouts({
          expandNodesFirst: false
        });
        this.orgChart = this.orgChart.setExpanded("org-root", true).setExpanded("org-root-job", true);
        data.orgTree.filter(function (e) {
          return e.parentId === "org-root-job";
        }).forEach(function (e) {
          return _this2.orgChart = _this2.orgChart.setExpanded(e.employeeId, true);
        });
        var curUser = data.orgTree.find(function (e) {
          return e.id === currentUser;
        });
        if (curUser) {
          curUser.highlight = true;
          //curUser._expanded = true;

          this.orgChart = this.orgChart.setExpanded(currentUser, true).setCentered(currentUser);
          data.orgTree.filter(function (e) {
            return e.parentId === currentUser;
          }).forEach(function (e) {
            return _this2.orgChart = _this2.orgChart.setExpanded(e.employeeId, true);
          });
        } else this.orgChart = this.orgChart.setCentered("org-root-job");

        /*setTimeout(t => {
                   this.orgChart = this.orgChart
                      .setExpanded("org-root", true)
                      .setExpanded("org-root-job", true)
                      .setExpanded(currentUser, true)
                      .render();
               }, 5000);*/

        //this.setExpanded(currentUser, true);

        /*this.orgChart = this.orgChart
                  //.setHighlighted(currentUser)
                  .setCentered(currentUser)
                  .setExpanded(currentUser, true)
              //.setUpToTheRootHighlighted(currentUser);*/

        data.orgTree.filter(function (e) {
          return e.parentId === currentUser;
        }).forEach(function (e) {
          return _this2.orgChart = _this2.orgChart.setExpanded(e.employeeId, true);
        });
      }
      this.orgChart = this.orgChart.render();
    }
  }, {
    key: "onDrag",
    value: function onDrag(e) {}
  }, {
    key: "onZoom",
    value: function onZoom(e, zoom) {
      var _this$props4 = this.props,
        minZoom = _this$props4.minZoom,
        maxZoom = _this$props4.maxZoom;
      this.zoom = zoom;
      if (this.zoomOutRef && this.zoomOutRef.current) this.zoomOutRef.current.setEnabled(zoom > minZoom);
      if (this.zoomInRef && this.zoomInRef.current) this.zoomInRef.current.setEnabled(zoom < maxZoom);
    }
  }, {
    key: "onPan",
    value: function onPan(e, x, y) {
      if (!this.centering && this.resetRef) this.resetRef.current.setEnabled(x !== this.center.x || y !== this.center.y);
    }
  }, {
    key: "centerOnOrg",
    value: function centerOnOrg() {
      var nodeWidth = this.props.nodeWidth;
      this.orgChart.zoomTreeBounds({
        params: {
          animate: true,
          scale: false
        },
        x0: -nodeWidth,
        x1: 0,
        y0: this.containerRef.current.clientHeight / 100 * 10,
        y1: this.containerRef.current.clientHeight
      });
    }
  }, {
    key: "onReset",
    value: function onReset(e) {
      var _this3 = this;
      if (!this.orgChart) return;
      var _this$props5 = this.props,
        currentUser = _this$props5.currentUser,
        data = _this$props5.data;
      var _this$orgChart$getCha = this.orgChart.getChartState(),
        svg = _this$orgChart$getCha.svg,
        zoomBehavior = _this$orgChart$getCha.zoomBehavior;
      svg.transition().duration(0).call(zoomBehavior.scaleTo, 1);
      var curUser = data.orgTree.find(function (e) {
        return e.id === currentUser;
      });
      setTimeout(function (t) {
        _this3.orgChart = _this3.orgChart.setExpanded("org-root", true).setExpanded("org-root-job", true);
        data.orgTree.filter(function (e) {
          return e.parentId === "org-root-job";
        }).forEach(function (e) {
          return _this3.orgChart = _this3.orgChart.setExpanded(e.employeeId, true);
        });
        _this3.orgChart = _this3.orgChart.setExpanded(curUser ? currentUser : "org-root-job", true).setCentered(curUser ? currentUser : "org-root-job");
        _this3.orgChart.fit({
          animate: true,
          scale: false,
          nodes: [_this3.getNode(curUser ? currentUser : "org-root-job")]
        });

        //this.orgChart = this.orgChart
        //.setExpanded(curUser ? currentUser : 'org-root-job', true)
        //.setCentered(curUser ? currentUser : 'org-root-job')
        //.render();
      }, 100);
      this.centering = true;
      setTimeout(function (t) {
        _this3.centering = false;
        _this3.center = _this3.orgChart.getChartState().lastTransform;
      }, 500);
      if (this.resetRef && this.resetRef.current) this.resetRef.current.setEnabled(false);
    }
  }, {
    key: "centerOn",
    value: function centerOn(employeeId) {
      try {
        if (!this.orgChart) return;
        this.orgChart = this.orgChart.setCentered(employeeId).render();
        var drag = d3.drag().on("start", function (event, d) {}).on("drag", function (event, d) {}).on("end", function (event, d) {});
        var _this$orgChart$getCha2 = this.orgChart.getChartState(),
          svg = _this$orgChart$getCha2.svg;
        svg = svg.call(drag);
      } catch (e) {}
    }
  }, {
    key: "nodeUpdate",
    value: function nodeUpdate(node, d, i, arr) {
      var _this4 = this;
      var nodeSelect = d3.select(node);
      if (d.data.type === "company") {
        nodeSelect.select(".node-button-g").attr("display", "none");
      }
      nodeSelect.select(".node-button-g").style("user-select", "none").on("mousedown", function (e, d) {
        return e.stopPropagation();
      });
      nodeSelect.select(".node-foreign-object-div").style("opacity", function (d) {
        return !_this4.searchResults || _this4.searchResults.includes(d.data) ? "1" : "0.2";
      }).style("filter", function (d) {
        return !_this4.searchResults || _this4.searchResults.includes(d.data) ? "none" : "grayscale(1)";
      });

      /*nodeSelect
              .select('.node-rect')
              .attr("stroke", d => d.data.highlight || d.data._upToTheRootHighlighted ? '#152785' : 'none')
              .attr("stroke-width", d.data.highlight || d.data._upToTheRootHighlighted ? 10 : 1);*/

      nodeSelect.select(".node-button-rect").attr("width", 54);
      var foreignObjSel = nodeSelect.select(".node-button-foreign-object").attr("x", -26).attr("y", -18).attr("width", 54);
      foreignObjSel.select(".node-button-div").style("pointer-events", "all");
      nodeSelect.select(".klayo-orgchart_node-morebutton").style("user-select", "none").on("mousedown", function (e, d) {
        return e.stopPropagation();
      }).on("click", function (e) {
        return _this4.onMore(e, node, d);
      });
      nodeSelect.select(".klayo_profilepic_badge").on("mouseenter", function (e) {
        return _this4.onCompliantBadgeMouseEnter(e, node, d);
      }).on("mouseleave", function (e) {
        return _this4.onCompliantBadgeMouseLeave(e, node, d);
      });
    }
  }, {
    key: "onCompliantBadgeMouseEnter",
    value: function onCompliantBadgeMouseEnter(e, node, d) {
      this.setState({
        tooltipText: d.data.isCompliant ? "Compliant" : "Non-compliant",
        tooltipTarget: e.target,
        tooltipOffset: {
          x: 16,
          y: -22
        }
      });
    }
  }, {
    key: "onCompliantBadgeMouseLeave",
    value: function onCompliantBadgeMouseLeave(e, node, d) {
      this.setState({
        tooltipText: null
      });
    }
  }, {
    key: "linkUpdate",
    value: function linkUpdate(link, d, i, arr) {
      var _this5 = this;
      d3.select(link).attr("stroke", function (d) {
        var parent = _this5.getEmployee(d.data.parentId);
        return d.data.highlight || parent && parent.highlight ? "var(--neon-blue-nb-500)" : "var(--neon-blue-nb-100)";
      }).attr("stroke-width", function (d) {
        var parent = _this5.getEmployee(d.data.parentId);
        return d.data.type === "company" || d.data.type === "nojob-root" ? 0 : d.data.highlight || parent && parent.highlight ? 2 : 1;
      }).style("opacity", function (d) {
        return !_this5.searchResults ? "1" : "0.2";
      });
      //.style('transition', 'stroke 150ms ease');

      if (d.data.highlight) {
        d3.select(link).raise();
      }
    }
  }, {
    key: "renderButton",
    value: function renderButton(args) {
      var node = args.node,
        state = args.state;
      if (node.data.type === "root") {
        return "";
      }
      return (0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(_OrgChartButton["default"], {
        expanded: node.children,
        numChildren: node.data._directSubordinates
      }));
    }
  }, {
    key: "onMore",
    value: function onMore(e, node, d) {
      this.setState({
        actionEmployee: d.data,
        actionTarget: e.target
      });
    }
  }, {
    key: "onCloseActionMenu",
    value: function onCloseActionMenu(e) {
      this.setState({
        actionTarget: null
      });
    }
  }, {
    key: "onViewProfile",
    value: function onViewProfile(e) {
      var onViewProfile = this.props.onViewProfile;
      var actionEmployee = this.state.actionEmployee;
      if (onViewProfile) onViewProfile(e, actionEmployee);
      this.setState({
        actionTarget: null
      });
    }
  }, {
    key: "onHighlight",
    value: function onHighlight(e) {
      var onHighlight = this.props.onHighlight;
      var actionEmployee = this.state.actionEmployee;
      //actionEmployee.highlight = !actionEmployee.highlight;

      var timeout = 0;
      /*if (actionEmployee.highlight && !actionEmployee._expanded) {
              this.setExpanded(actionEmployee.employeeId, true);
              this.orgChart.render();
              timeout = 500;
          }*/

      //setTimeout(t => {
      this.setHighlight(actionEmployee.employeeId, !actionEmployee.highlight);

      /*this.orgChart = this.orgChart
              .setExpanded("org-root", true)
              .setExpanded("org-root-job", true)
              .setExpanded(actionEmployee.employeeId, true)
              //.render();*/

      //this.orgChart.updateNodesState();
      this.orgChart.clearHighlighting();
      if (onHighlight) onHighlight(e, actionEmployee);
      this.setState({
        actionTarget: null
      });
      //}, timeout);
    }
  }, {
    key: "getChildren",
    value: function getChildren(id) {
      return Object.values(this.props.data.orgTree).filter(function (e) {
        return e.parentId === id;
      });
    }
  }, {
    key: "getEmployee",
    value: function getEmployee(employeeId) {
      return this.props.data.orgTree.find(function (e) {
        return e.employeeId === employeeId;
      });
    }
  }, {
    key: "setCentered",
    value: function setCentered(employeeId, centered) {
      this.orgChart.setCentered(employeeId, centered);
    }
  }, {
    key: "setExpanded",
    value: function setExpanded(employeeId, expanded) {
      var _this6 = this;
      var data = this.props.data;
      this.orgChart = this.orgChart.setExpanded(employeeId, expanded);
      //this.getChildren(employeeId).forEach(e => this.setExpanded(e.employeeId, expanded));

      this.getChildren(employeeId).forEach(function (e) {
        var node = _this6.getNode(e.employeeId);
        _this6.setExpanded(e.employeeId, node.data._expanded === true);
      });
    }
  }, {
    key: "expandAllParents",
    value: function expandAllParents(employee) {
      var parent = this.getEmployee(employee.parentId);
      while (parent) {
        this.setExpanded(parent.employeeId, true);
        parent = this.getEmployee(parent.parentId);
      }
      this.orgChart = this.orgChart.setExpanded("org-root", true).setExpanded("org-root-job", true);
    }
  }, {
    key: "setHighlight",
    value: function setHighlight(employeeId, highlight) {
      var employee = this.getEmployee(employeeId);
      var node = this.getNode(employeeId);
      employee.highlight = highlight;
      //this.orgChart = this.orgChart.setExpanded(employeeId, node._expanded);
      this.setExpanded(employeeId, true);
      this.expandAllParents(employee);
    }
  }, {
    key: "renderNode",
    value: function renderNode(d, i, arr, state) {
      var _this$props6 = this.props,
        centerOn = _this$props6.centerOn,
        organization = _this$props6.organization;
      if (d.data.type === "root") return "";
      if (d.data.type === "company") {
        var highlightedChildren = this.getChildren(d.data.id).filter(function (e) {
          return e.highlight;
        }).length;
        return (0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(_OrgChartCompanyNode["default"], {
          key: d.data.id,
          organization: organization,
          data: d.data,
          inHighlightPath: highlightedChildren
        }));
      }
      if (d.data.type === "person") {
        var parent = this.getEmployee(d.data.parentId);
        return (0, _server.renderToStaticMarkup)(/*#__PURE__*/_react["default"].createElement(_OrgChartPersonNode["default"], {
          key: d.data.id,
          data: d.data,
          onMore: this.onMore.bind(this),
          focused: d.data.highlight,
          inHighlightPath: d.data.highlight || parent && parent.highlight
        }));
      }
      if (d.data.type === "nojob-root") {
        return null; //'<div style="text-align:center">Unassigned</div>'
      }
    }
  }, {
    key: "onZoomOut",
    value: function onZoomOut(e) {
      if (!this.orgChart) return;
      this.orgChart.zoomOut();
      this.zoom -= 1.3;
    }
  }, {
    key: "getNode",
    value: function getNode(nodeId) {
      var data = this.props.data;
      if (!data || !this.orgChart) return;
      var _this$orgChart$getCha3 = this.orgChart.getChartState(),
        allNodes = _this$orgChart$getCha3.allNodes;
      if (!allNodes) return;
      return allNodes.filter(function (d) {
        return d.data.id === nodeId;
      })[0];
    }
  }, {
    key: "onZoomIn",
    value: function onZoomIn(e) {
      if (!this.orgChart) return;
      this.orgChart.zoomIn();
      this.zoom += 1.3;
    }
  }, {
    key: "setZoom",
    value: function setZoom() {
      if (!this.orgChart) return;
      var _this$orgChart$getCha4 = this.orgChart.getChartState(),
        svg = _this$orgChart$getCha4.svg,
        zoomBehavior = _this$orgChart$getCha4.zoomBehavior;
      svg.transition().duration(0).call(zoomBehavior.scaleTo, 1);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
        currentUser = _this$props7.currentUser,
        data = _this$props7.data;
      var _this$state = this.state,
        actionTarget = _this$state.actionTarget,
        actionEmployee = _this$state.actionEmployee,
        tooltipText = _this$state.tooltipText,
        tooltipTarget = _this$state.tooltipTarget,
        tooltipOffset = _this$state.tooltipOffset,
        searchAnchorEl = _this$state.searchAnchorEl,
        searchValue = _this$state.searchValue;

      //if (!actionTarget)
      if (this.firstDraw) {
        this.renderOrgChart();
      }
      var rootChildren = null;
      if (data) rootChildren = this.getChildren("org-root-job");
      if (rootChildren && rootChildren.length === 0) return /*#__PURE__*/_react["default"].createElement("div", {
        className: "klayo-orgchart"
      }, /*#__PURE__*/_react["default"].createElement(_Placeholder["default"], {
        text: {
          primary: "Org chart not available",
          secondary: "Create some employees and assign them jobs to generate the org chart"
        },
        icon: /*#__PURE__*/_react["default"].createElement(_iconsOrgChart.ReactComponent, null),
        sx: {
          marginTop: "20%"
        }
      }));
      if (this.isSafari) return /*#__PURE__*/_react["default"].createElement("div", {
        className: "klayo-orgchart"
      }, /*#__PURE__*/_react["default"].createElement(_Placeholder["default"], {
        text: {
          primary: "Incompatible browser",
          secondary: "This feature doesn't work on Safari. Please use a different browser"
        },
        icon: /*#__PURE__*/_react["default"].createElement(_iconsWarning.ReactComponent, null),
        sx: {
          marginTop: "20%"
        }
      }));
      var employeeOptions = data ? data.employees.filter(function (emp) {
        return !emp.isVacancy;
      }).map(function (emp) {
        return {
          employeeId: emp.employeeId,
          label: emp.fullName || ""
        };
      }) : [];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "klayo-orgchart",
        style: {
          width: "100%",
          height: "100%"
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
        className: "klayo-orgchart_controls",
        sx: {
          position: "absolute",
          right: 0,
          bottom: 0,
          margin: {
            xs: "16px",
            sm: "32px",
            md: "32px",
            lg: "48px",
            xl: "48px"
          }
        }
      }, /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], {
        size: "sm",
        buttons: [{
          ref: this.searchRef,
          icon: /*#__PURE__*/_react["default"].createElement(_iconsSearch.ReactComponent, null),
          onClick: this.handleSearchClick
        }, {
          ref: this.zoomOutRef,
          icon: /*#__PURE__*/_react["default"].createElement(_iconsZoomout.ReactComponent, null),
          //tooltip: 'Zoom out',
          toolTipEnterDelay: 500,
          onClick: this.onZoomOut.bind(this)
        }, {
          ref: this.resetRef,
          icon: /*#__PURE__*/_react["default"].createElement(_iconsCenter.ReactComponent, null),
          disabled: true,
          //tooltip: 'Re-center',
          toolTipEnterDelay: 500,
          onClick: this.onReset.bind(this)
        }, {
          ref: this.zoomInRef,
          icon: /*#__PURE__*/_react["default"].createElement(_iconsZoomin.ReactComponent, null),
          //tooltip: 'Zoom in',
          toolTipEnterDelay: 500,
          onClick: this.onZoomIn.bind(this)
        }],
        sx: {
          boxShadow: "rgb(248 248 254) 0px 0px 17px 20px"
        }
      })), /*#__PURE__*/_react["default"].createElement(_material.Popover, {
        open: Boolean(searchAnchorEl),
        anchorEl: searchAnchorEl,
        onClose: this.handleSearchClose,
        anchorOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "bottom",
          horizontal: "left"
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
        sx: {
          p: 3,
          width: 400
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Autocomplete, {
        options: employeeOptions,
        renderInput: function renderInput(params) {
          return /*#__PURE__*/_react["default"].createElement(_material.TextField, _extends({}, params, {
            className: "klayo-textfield " + "klayo-textfield-dense " + "klayo-textfield--autofilled",
            size: "small",
            placeholder: "Search employees...",
            autoFocus: true
          }));
        },
        onChange: this.handleEmployeeSelect,
        value: this.state.selectedEmployee,
        isOptionEqualToValue: function isOptionEqualToValue(option, value) {
          return option.employeeId === value.employeeId;
        },
        autoComplete: true,
        autoHighlight: true,
        clearOnBlur: false,
        sx: {
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: _klayowebshared.Theme.getStyleVar("--neon-blue-nb-200")
            },
            "&:hover fieldset": {
              borderColor: _klayowebshared.Theme.getStyleVar("--neon-blue-nb-300")
            },
            "&.Mui-focused fieldset": {
              borderWidth: "2px",
              borderColor: _klayowebshared.Theme.getStyleVar("--neon-blue-nb-500")
            }
          }
        }
      }))), /*#__PURE__*/_react["default"].createElement(_material.Box, {
        ref: this.containerRef,
        sx: {
          width: "100%",
          overflow: "visible",
          height: "100%",
          "&>svg": {
            width: "100%",
            height: "100%"
          }
        }
      }), tooltipText && /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        open: true,
        title: tooltipText,
        anchorEl: tooltipTarget,
        placement: "right",
        sx: {
          position: "absolute",
          whiteSpace: "nowrap",
          pointerEvents: "none",
          marginLeft: tooltipOffset.x + "px!important",
          marginTop: tooltipOffset.y + "px"
        }
      }, /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement(_material.Menu, {
        open: actionTarget !== null,
        anchorEl: actionTarget,
        onClose: this.onCloseActionMenu.bind(this)
      }, /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
        onClick: this.onHighlight.bind(this)
      }, actionEmployee && actionEmployee.highlight ? "Remove highlight" : "Highlight connections"), actionEmployee && actionEmployee.isMyTeam && /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
        onClick: this.onViewProfile.bind(this)
      }, "View employee profile")));
    }
  }]);
}(_react.Component);
_defineProperty(OrgChart, "defaultProps", {
  minZoom: 0.2,
  maxZoom: 2,
  nodeWidth: 260
});